import { render, staticRenderFns } from "./PosSelect.vue?vue&type=template&id=7430d150&"
import script from "./PosSelect.vue?vue&type=script&lang=js&"
export * from "./PosSelect.vue?vue&type=script&lang=js&"
import style0 from "./PosSelect.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports